﻿export class LPXCtrlPools_v5ABI
{
    public static GetABI():any
    {
        return [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "lpx_",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "lpxLibArbProfit_",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"stateMutability": "payable",
		"type": "fallback"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "fundValue_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "anchorValue_",
				"type": "uint256"
			}
		],
		"name": "addLiquidity",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "upToBalance_",
				"type": "uint256"
			}
		],
		"name": "bot_feed",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "newLPXCostETH_",
				"type": "uint256"
			}
		],
		"name": "bot_setNewLPXCostETH",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "bots",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1.Reserve",
				"name": "reserve_",
				"type": "tuple"
			}
		],
		"name": "calcCurrentRatio",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "ratio_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1.Reserve",
				"name": "reserve_",
				"type": "tuple"
			},
			{
				"internalType": "uint32",
				"name": "fee_",
				"type": "uint32"
			}
		],
		"name": "calcEndRatio",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "ratio_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1.Reserve",
				"name": "reserve_",
				"type": "tuple"
			},
			{
				"internalType": "uint32",
				"name": "fee_",
				"type": "uint32"
			}
		],
		"name": "calcStartRatio",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "ratio_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256[]",
				"name": "poolIds_",
				"type": "uint256[]"
			},
			{
				"internalType": "bool",
				"name": "unsafe_",
				"type": "bool"
			}
		],
		"name": "claimProfits",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "controllers",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "deposit",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolType_",
				"type": "uint256"
			}
		],
		"name": "feeGlobalPack",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "pack_",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint32",
						"name": "feeIndex",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "ntzIndex",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "profitIndex",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "managerRewardIndex",
						"type": "uint32"
					},
					{
						"internalType": "uint8",
						"name": "poolType",
						"type": "uint8"
					}
				],
				"internalType": "struct ILPXv1.ConfigPack",
				"name": "unpack_",
				"type": "tuple"
			}
		],
		"name": "getPackConfigPack",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "result_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint8",
						"name": "inPathPosition",
						"type": "uint8"
					},
					{
						"internalType": "uint8",
						"name": "outPathPosition",
						"type": "uint8"
					},
					{
						"internalType": "uint64",
						"name": "part",
						"type": "uint64"
					},
					{
						"internalType": "uint128",
						"name": "poolId",
						"type": "uint128"
					}
				],
				"internalType": "struct ILPXv1.SwapStep",
				"name": "unpack_",
				"type": "tuple"
			}
		],
		"name": "getPackSwapStep",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "step_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "forAddress_",
				"type": "address"
			}
		],
		"name": "getProfit",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "anchorProfit_",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "lpx",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "lpxLibArbProfit",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "manager",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "tokens_",
				"type": "address[]"
			},
			{
				"internalType": "bool",
				"name": "approved_",
				"type": "bool"
			}
		],
		"name": "mngr_setApprovedERC20Tokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "bots_",
				"type": "address[]"
			},
			{
				"internalType": "bool",
				"name": "value_",
				"type": "bool"
			},
			{
				"internalType": "uint256",
				"name": "preFeedEth_",
				"type": "uint256"
			}
		],
		"name": "mngr_setBots",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "controllers_",
				"type": "address[]"
			},
			{
				"internalType": "bool",
				"name": "value_",
				"type": "bool"
			}
		],
		"name": "mngr_setControllers",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint32",
				"name": "ntzIndex_",
				"type": "uint32"
			},
			{
				"internalType": "uint32",
				"name": "profitIndex_",
				"type": "uint32"
			},
			{
				"internalType": "uint32",
				"name": "feeIndex_",
				"type": "uint32"
			}
		],
		"name": "mngr_setFee",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "manager_",
				"type": "address"
			}
		],
		"name": "mngr_setManager",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newLPXReward_",
				"type": "address"
			}
		],
		"name": "mngr_setNewLPXReward",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint8",
				"name": "flag_",
				"type": "uint8"
			},
			{
				"internalType": "bool",
				"name": "value_",
				"type": "bool"
			}
		],
		"name": "mngr_setPoolFlag",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "mngr_withdraw",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "erc20Address_",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount_",
				"type": "uint256"
			}
		],
		"name": "mngr_withdrawERC20",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "newLPXCostETH",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "newLPXReward",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "pack",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "manager",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "fundToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorToken",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalShares",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1.Config",
				"name": "config_",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			}
		],
		"name": "poolCreate",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "fundReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "fundImgReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorReserve",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "anchorImgReserve",
						"type": "uint256"
					}
				],
				"internalType": "struct ILPXv1.Reserve",
				"name": "reserve_",
				"type": "tuple"
			}
		],
		"name": "poolStart",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolId_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "shareAmount_",
				"type": "uint256"
			}
		],
		"name": "removeLiquidity",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "pack_",
				"type": "uint256"
			},
			{
				"internalType": "uint8",
				"name": "flag_",
				"type": "uint8"
			}
		],
		"name": "setPackConfigFlag",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "result_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "pack_",
				"type": "uint256"
			},
			{
				"internalType": "uint8",
				"name": "flag_",
				"type": "uint8"
			}
		],
		"name": "unsetPackConfigFlag",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "result_",
				"type": "uint256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "version",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"stateMutability": "payable",
		"type": "receive"
	}
];
    }
}